import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-726c708a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "container",
  class: "container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ColorPopover = _resolveComponent("ColorPopover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "gradient",
      style: _normalizeStyle({ background: _ctx.gradient })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "rail",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addColorStop && _ctx.addColorStop(...args)))
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.absColorStop, (colorStop, ix) => {
          return (_openBlock(), _createElementBlock("div", {
            ref_for: true,
            ref: _ctx.setKnobRef(ix),
            key: ix,
            class: "knob",
            style: _normalizeStyle({ left: `${colorStop.pos}%` }),
            onPointerdown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDrag($event)))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['knob-icon', { active: _ctx.dragTarget === ix }]),
              style: _normalizeStyle({ background: colorStop.color })
            }, null, 6 /* CLASS, STYLE */)
          ], 36 /* STYLE, HYDRATE_EVENTS */))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */)
    ], 4 /* STYLE */),
    _createVNode(_component_ColorPopover, {
      ref: "popover",
      show: _ctx.colorPickerTarget != null,
      el: _ctx.colorPickerTarget != null ? _ctx.knobRefs[_ctx.colorPickerTarget] : null,
      "on-hide": _ctx.onHide,
      "model-value": _ctx.colorPickerTarget != null ? _ctx.absColorStop[_ctx.colorPickerTarget].color : '',
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateColor($event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Button, {
          danger: "",
          block: "",
          onClick: _ctx.deleteColorStop
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Delete),
            _createTextVNode(" 削除 ")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show", "el", "on-hide", "model-value"])
  ], 64 /* STABLE_FRAGMENT */))
}